import Modal from "@/components/ui/modal";
import PrimaryButton from "@/components/ui/primary-button";
import { Info } from "react-feather";

export interface NoLocationNearYourSearchProps {
  type: "inline" | "modal";
  onClose?: () => void;
}

const NoLocationNearYourSearch: React.FC<NoLocationNearYourSearchProps> = ({
  type,
  onClose,
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  if (type === "inline") {
    return (
      <div className="flex flex-col gap-2">
        <div className="flex flex-row gap-2 font-montserrat text-heading-4 text-neutral-600">
          <span>
            <Info
              size={32}
              className="text-primary-500"
            />
          </span>
          <span>No Location Near Your Search</span>
        </div>
        <p className="w-full font-montserrat text-body-1-300 text-neutral-600">
          Try adjusting your search or contact us to request our service in your
          area.
        </p>
        <div className="flex">
          <PrimaryButton
            color="teal"
            href="/contact-us"
          >
            Reach Out to Us
          </PrimaryButton>
        </div>
      </div>
    );
  } else {
    return (
      <Modal
        className="absolute left-1/2 top-1/2 z-40 mx-auto -translate-x-1/2 -translate-y-1/2"
        title="No Location Near Your Search"
        description="Try adjusting your search or contact us to request our service in your area."
        onClose={handleClose}
        isOpen={true}
      />
    );
  }
};

export default NoLocationNearYourSearch;
